import React from 'react';
import { applyBgColor } from '../../utils/utils';
import { classNames } from '../../utils/style';
import { PayFitColor } from '../../types/module';
import { Mosaic, MosaicItem } from '../../components/Mosaic';
import { textBodyLarge, textSerifTitle1 } from '../../styles/typography';
import { container } from '../../styles/themes';

export interface HeroMosaicProps {
  backgroundColor: PayFitColor;
  className?: string;
  title: string;
  subtitle?: string;
  items?: MosaicItem[];
}

export const HeroMosaic = ({
  backgroundColor = 'white',
  className = '',
  title,
  subtitle,
  items = [],
}: HeroMosaicProps) => {
  return (
    <section
      className={classNames(
        'HeroMosaic',
        className,
        applyBgColor(backgroundColor),
        'overflow-hidden',
        'pt-[64px] pb-[64px]',
        'md:pt-[104px] md:pb-[104px]',
      )}
    >
      <div
        className={classNames(
          container,
          `flex flex-col items-center text-center`,
        )}
      >
        <div
          className={classNames(
            `mb-64`,
            'lg:max-w-[483px] lg:w-full',
            'xl:max-w-[736px]',
          )}
        >
          {/* To match the Hero */}
          <h1
            className={classNames(
              textSerifTitle1,
              `mb-24 text-neutral-301`,
            )}
          >
            {title}
          </h1>
          {subtitle && (
            <div className={classNames(textBodyLarge, `text-neutral-101`)}>
              {subtitle}
            </div>
          )}
        </div>
        <Mosaic items={items} />
      </div>
    </section>
  );
};
